import { FORM_ERROR } from 'final-form'
import { CategoriaSubstanciaAlergia } from 'graphql/types.generated'
import moment from 'moment'
import { createValidator, range, required } from 'util/validation'
import { isEmpty } from 'util/validation/Util'

import { AlergiaReacaoModel } from '../alergias-reacoes/model'
import { DataProblemaFieldModel } from './DataProblemaField'
import { ProblemaCondicaoModel } from './model'

export const alergiasReacoesValidator = (dataNascimentoCidadao: LocalDate, dataInicioAtendimento: Instant) =>
  createValidator<AlergiaReacaoModel>(
    {
      dataInicio: dataProblemaValidator(dataNascimentoCidadao, dataInicioAtendimento),
      categoriaSubstancia: [required],
    },
    (formValues, errors) => {
      if (formValues?.categoriaSubstancia && formValues.categoriaSubstancia === CategoriaSubstanciaAlergia.BIOLOGICO) {
        errors.substanciaImunobiologico = required(formValues?.substanciaImunobiologico)
      } else {
        errors.substanciaCbara = required(formValues?.substanciaCbara)
      }

      return errors
    }
  )

export const problemasCondicoesValidator = (
  somenteCiap: boolean,
  values: Array<ProblemaCondicaoModel>,
  isEdit: boolean,
  dataInicioAtendimento: Instant,
  dataNascimentoCidadao: LocalDate
) =>
  createValidator<ProblemaCondicaoModel>(
    {
      dataInicio: dataProblemaValidator(dataNascimentoCidadao, dataInicioAtendimento),
      dataFim: dataProblemaValidator(dataNascimentoCidadao, dataInicioAtendimento),
    },
    (formValues, errors) => {
      if (somenteCiap) {
        errors.ciap = required(formValues.ciap)
      } else {
        const emptyFields = isEmpty(formValues.ciap) && isEmpty(formValues.cid)
        errors[FORM_ERROR] = emptyFields && 'Pelo menos um dos campos é de preenchimento obrigatório.'

        if (!emptyFields) {
          const hasItem =
            (values || []).find(
              (o2) =>
                formValues?.ciap?.id === o2.ciap?.id &&
                formValues?.cid?.id === o2.cid?.id &&
                (isEdit ? formValues._id !== o2._id : true)
            ) !== undefined
          errors[FORM_ERROR] = hasItem && 'Este relacionamento de CIAP2 e CID10 já está adicionado.'
        }
      }

      if (formValues.incluirNaListaProblemas) {
        errors.situacaoProblema = required(formValues.situacaoProblema)

        if (
          formValues?.dataFim?.data &&
          formValues?.dataInicio?.data &&
          moment(formValues.dataFim.data).isBefore(moment(formValues.dataInicio.data))
        ) {
          errors.dataFim = { data: 'Deve ser posterior ou igual ao Início do problema.' }
        }
      }

      return errors
    }
  )

const dataProblemaValidator = (dataMinima: LocalDate, dataMaxima: number) =>
  createValidator<DataProblemaFieldModel>({}, (formValues, errors) => {
    if (formValues) {
      errors.idade = range(0, 11)(formValues?.idade?.meses) && 'Meses deve ter valor entre 0 e 11.'

      if (!errors.idade) errors.idade = range(0, 999)(formValues?.idade?.anos) && 'Anos deve ter valor entre 0 e 999.'

      if (moment(formValues.data).isBefore(moment(dataMinima))) {
        errors.data = 'Deve ser posterior ou igual à Data de nascimento do cidadão.'
      }

      if (moment(formValues.data).startOf('day').isAfter(moment(dataMaxima))) {
        errors.data = 'Deve ser anterior ou igual à Data do atendimento.'
      }
    }

    return errors
  })
